export default __webpack_public_path__ + "static/media/talismanmastery.beb02bc6.png";